import Row from '@components/Row';
import Text from '@components/Text';
import styled from '@emotion/styled';

import Side from '../Side';

interface Props {
    shopName: string;
}

function TopRow({ shopName }:Props) {
    return (
        <Container >
            <Bar />
            <RightSide/>
            <ShopName>{shopName}</ShopName>
        </Container>
    );
}

const Container = styled(Row)`
    margin-bottom: -1px;
`;

const Bar = styled.div`
    background-color: var(--color-gray6);
    height: 17px;
    border-top-left-radius: 12px;
    flex: 1;
    margin-bottom: -1px;
`;

const RightSide = styled(Side)`
    margin-bottom: -2px;
    margin-left: -2px;
`;

const ShopName = styled(Text)`
    margin-right: 4px;
    margin-top: -9px;
    opacity: 0;
`;

export default TopRow;
